import { useEffect, useRef, useState } from "react";
import websocketContext from "./websocketContext";
import { WEB_SOCKET_URL } from "configs/AppConfig";
// import { WEB_SOCKET_URL } from "./AppConfig";
import { USER_ID } from "constants/AuthConstant";
import ViewService from "services/ViewService";
import {
  FACEBOOK_AUTH_CONFIG_ID,
  FACEBOOK_AUTH_APP_ID,
} from "configs/AppConfig";
import { openNotification } from "utils/livestream-notifications/LivestreamNotifications";
import { message } from "antd";
import { useMediaQuery } from "react-responsive";

const WebSocketProvider = ({ children }) => {
  const [socket, setSocket] = useState({});
  const [facebookStreamConfig, setFacebookStreamConfig] = useState(null);
  const [isInputFiledFocused, setIsInputFiledFocusd] = useState(false);
  const [facebookCommentsConfig, setFacebookCommentsConfig] = useState(null);
  const [facebookComments, setFacebookComments] = useState([]);
  const facebookAPIPollingTime = 15000;
  //   const MAX_RETRIES = 5;
  //   let retryCount = 0;
  const [isNewComments, setIsNewComments] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const streamId = urlParams.get("stream_id");
  const role_parms = urlParams.get("role");
  const tabRef = useRef("1");
  const drawerTabRef = useRef("commentsTab");
  const [colorCode, setColorCode] = useState("grey");
  const [youtubeColorCode, setYoutubeColorCode] = useState("grey");
  const [authenticationRedirect, setAuthenticationRedirect] = useState(false);
  const [messages, setMessages] = useState({
    message: "",
    status: 200,
  });

  const [youtubeMessage, setYoutubeMessage] = useState({
    message: "",
    status: 200,
  });

  const [config, setConfig] = useState(null);
  const [replingTo, setReplingTo] = useState("");
  const [activeProduct, setActiveProduct] = useState([]);
  const activeProductRef = useRef(activeProduct);
  const streamingInfoRef = useRef(null);
  const [newFeeds, setNewFeeds] = useState([]);
  const [editStatus, setEditStatus] = useState(false);
  const [editItem, setEditItem] = useState();
  const [reelsSelectedRange, setReelsSelectedRange] = useState(null);
  const [reelsCurrentPage, setReelsCurrentPage] = useState(1);
  const [youtubeStreamConfig, setYoutubeStreamConfig] = useState(null);
  const [youtubeComments, setYoutubeComments] = useState([]);
  const youtubePageTokenRef = useRef(null); // Use useRef for youtubePageToken
  const [youtubeCommentsConfig, setYoutubeCommentsConfig] = useState(null);
  const [chatId, setYoutubeChatId] = useState(null);
  const youtubeTokenRef = useRef(null); // Use useRef for youtubeToken
  const website = localStorage.getItem("website");
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [instgramTokenConfig, setInstagramTokenConfig]= useState(null);
  const [instagramComments, setInstgramComments]= useState([]);
  const [instagramCommentConfig, setInstagramCommentConfig]= useState(null);
  const [instagramColorCode, setInstgramColorCode] = useState("grey");
  const multiStreamTokenConfigFacebook=useRef({});
  //status
  const [online, setOnline] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleSocket = () => {
    // console.log("Inside Handle Socket");
    const sockett = new WebSocket(
      `${WEB_SOCKET_URL}?id=${localStorage.getItem(
        USER_ID
      )}&type=cms&source=cms`
    );
    // setSocket(sockett);
    return sockett;
  };

  const handleFacebookAuthStatus = async () => {
    try {
      const response = await ViewService.getFacebookAuthStatus();
      console.log("getFacebookAuthStatus", response.data);
      getFacebookToken();
    } catch (error) {
      console.log(
        "Error in getFacebookAuthStatus getFacebookAuthStatus",
        error
      );
      if (error.response && error.response.status === 403) {
        openNotification("Facebook");
        setMessages({ message: error.response.data.message, status: 403 });
      }
    }
  };

  const handleFacebookAuthStatusAuthIds = async (auth_ids) => {
    try {
      const response = await ViewService.getFacebookAuthStatus();
      console.log("getFacebookAuthStatus", auth_ids);
      handleMultipleFacebookStreamsToken(auth_ids);
    } catch (error) {
      console.log(
        "Error in getFacebookAuthStatus getFacebookAuthStatus",
        error
      );
      if (error.response && error.response.status === 403) {
        openNotification("Facebook");
        setMessages({ message: error.response.data.message, status: 403 });
      }
    }
  };

  let retryCount = 0;
  let youtubeCommentRetryCount = 0;

  //instagram get comments
  const handleGetInstagramToken= async ()=>{
    try {
      const id = streamId;
      const response= await ViewService.getInstagramLiveStreamToken(id);
      setInstagramTokenConfig(response?.data);
      const insta_handle= response?.data?.account_handle;
      const insta_media_id= response?.data?.insta_video_id;
      const insta_video_id= response?.data?.insta_stream_id;
      const insta_token= response?.data?.token;
      if(insta_handle && insta_media_id && insta_video_id){
        setInstgramColorCode("red")
        setInterval(() => {
          getInstagramComments(insta_token, insta_media_id);
        }, facebookAPIPollingTime);
        getInstagramComments(insta_token, insta_media_id);
      }
      else{
        throw new Error("Error in getting live stream ready");
      }
    } catch (error) {
      setInstgramColorCode("grey");
      if (error.response && error.response.status === 400) {
        setTimeout(()=>{
          handleGetInstagramToken();
        },3000)
      }
      if (error.response && error.response.status === 403) {
        message.error(error.response.data.message || "Error in live stream on instagram");
      }
    }
  }

  const getInstagramComments = async (token, mediaId) => {
    try {
      const response = await fetch(
        `https://graph.instagram.com/${mediaId}/comments?access_token=${token}&fields=text,username,timestamp,from`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Facebook comments");
      }
      const data = await response.json();
      const updatedData= data?.data?.map((commentInfo, index) => {
          let obj = {
            name: commentInfo?.from?.username,
            comment: commentInfo?.text,
            imgUrl: null,
            id: commentInfo?.id,
            source:
              commentInfo?.username 
                ? "HOST"
                : "USER",
            alignment:
              commentInfo?.username
                ? "right"
                : "left",
            isReplied: false,
            commentDetails: { ...commentInfo },
            replying_user: null,
          };
          return obj
      });
      const updatedInstgaramComments= updatedData.reverse();
      setInstgramComments([...updatedInstgaramComments]);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const postCommentToInstagram= async (comment,insta_auth_id)=>{
    try {
      const data= {
        broadcast_id: instgramTokenConfig?.insta_stream_id,
        insta_auth_id,
        comment: isInputFiledFocused ? `@${instagramCommentConfig?.name}, ${comment}`: comment
      }

      await ViewService.postInstgramComment(data);

      const commentObj= {
        name: instgramTokenConfig?.account_handle || "You",
        comment: isInputFiledFocused ? `@${instagramCommentConfig?.name}, ${comment}`: comment,
        imgUrl: null,
        id: instagramComments?.length,
        source: role_parms == 2 ? "MODERATOR" : "HOST",
        alignment: "right",
        isReplied: false,
        commentDetails: {},
        replying_user: isInputFiledFocused? instagramCommentConfig : null,
      };

      setInstgramComments((data)=>[...data, commentObj]);
      setIsInputFiledFocusd(false);
      
    } catch (error) {
      message.error("Error in posting comment");
    }
  }

  const handleYoutubeAuthStatus = async () => {
    try {
      const response = await ViewService.getYouTubeAuthStatus();
      console.log("getYoutubeAuthStatus", response.data);
      getYoutubeToken();
    } catch (error) {
      console.log("Error in getYoutubeAuthStatus", error);
      if (error.response && error.response.status === 403) {
        openNotification("Youtube");
        setYoutubeMessage({
          message: error.response.data.message,
          status: 403,
        });
      }
    }
  };

  const handleAgainYoutubeAuthStatus = async () => {
    try {
      const id = streamId;
      const response = await ViewService.getYouTubeAuthStatus();
      let tokenResponse = await ViewService.getYoutubeAccessTokenForLivestream(
        id
      );
      const { token } = tokenResponse?.data;
      youtubeTokenRef.current = token;
    } catch (error) {
      console.log("Error in getYoutubeAuthStatus", error);
      if (error.response && error.response.status === 403) {
        openNotification("Youtube");
        setYoutubeMessage({
          message: error.response.data.message,
          status: 403,
        });
      }
    }
  };

  const getFacebookToken = async () => {
    try {
      const id = streamId;
      let response = await ViewService.getFacebookAccessTokenForLivestream(id);
      console.log("facebook token", response.data);
      const fbStreamId = response?.data;
      setColorCode("red");
      setMessages({ message: "No comments", status: 200 });
      setFacebookStreamConfig(fbStreamId);

      getFacebookComments(fbStreamId);
      setInterval(() => {
        getFacebookComments(fbStreamId);
      }, facebookAPIPollingTime);
    } catch (error) {
      console.log("Error in getFacebookAccessTokenForLivestream, API", error);
      setColorCode("grey");
      if (error.response && error.response.status === 400) {
        setMessages({ message: error.response.data.message, status: 400 });
        console.log("Retrying getFacebookToken in 5 seconds...");
        setTimeout(() => getFacebookToken(), 5000);
      }
      if (error.response && error.response.status === 403) {
        setMessages({ message: error.response.data.message, status: 403 });
      }
    }
  };

  const getFacebookTokenSpecificAuthId = async (auth_id) => {
    try {
      const id = streamId;
      console.log("totken auth id",auth_id);
      let response = await ViewService.getFacebookAccessTokenForLivestreamMulti(id, auth_id);
      const fbStreamId = response?.data;
      const newData={}
      newData[`${auth_id}`]= fbStreamId;
      multiStreamTokenConfigFacebook.current={
        ...multiStreamTokenConfigFacebook.current,
        ...newData
      };
      // dispatch(updateMultiStreamTokenConfig(newData));
      // setFacebookStreamConfig(fbStreamId);

      // console.log("fbStreamId", fbStreamId);
      getFacebookCommentsAuthId(fbStreamId, auth_id);
      setInterval(() => {
        getFacebookCommentsAuthId(fbStreamId, auth_id);
      }, 15000);
      return fbStreamId;;
    } catch (error) {
      // console.log("Error in getFacebookAccessTokenForLivestream, API", error);
      // setColorCode("grey");
      if (error.response && error.response.status === 400) {
        // setMessages({ message: error.response.data.message, status: 400 });
        // console.log("Retrying getFacebookToken in 5 seconds...");
        console.log("error auth id", auth_id);
        setTimeout(() => getFacebookTokenSpecificAuthId(auth_id), 5000);
      }
      if (error.response && error.response.status === 403) {
        // setMessages({ message: error.response.data.message, status: 403 });
        message.error(error.response.data.message)
      }
    }
  };

  const handleMultipleFacebookStreamsToken= async (auth_ids)=>{
    let showLive= false;
    for(let i=0;i<auth_ids.length;i++){
      try {
        console.log("auth_id",auth_ids[i])
        await getFacebookTokenSpecificAuthId(auth_ids[i]);
      } catch (error) {
        console.log(error);
      }
    }
    if(checkColorCodeFacebook()){
      setColorCode("red");
    }
    else{
      setColorCode("grey")
    }
  }

  const checkColorCodeFacebook=()=>{
    // console.log("multiStreamTokenConfigFacebook",Object.values(multiStreamTokenConfigFacebook.current));
    return Object.values(multiStreamTokenConfigFacebook.current).length>0?true:false
  }

  const getYoutubeToken = async () => {
    try {
      const id = streamId;
      let response = await ViewService.getYoutubeAccessTokenForLivestream(id);
      console.log("Youtube token", response.data);
      const { token, yt_video_id } = response?.data;
      youtubeTokenRef.current = token;
      let chatIdResponse = await ViewService.getYoutubeChatId(
        token,
        yt_video_id
      );
      const youtubeChatId = chatIdResponse.data.items[0]?.snippet?.liveChatId;
      setYoutubeChatId(youtubeChatId);
      setYoutubeColorCode("red");
      setYoutubeMessage({ message: "No comments", status: 200 });
      setYoutubeStreamConfig(chatIdResponse.data.items[0]);
      getYoutubeComments(
        youtubeTokenRef.current,
        youtubeChatId,
        youtubePageTokenRef.current
      );
      setInterval(() => {
        getYoutubeComments(
          youtubeTokenRef.current,
          youtubeChatId,
          youtubePageTokenRef.current
        );
      }, facebookAPIPollingTime);
    } catch (error) {
      console.log("Error in getFacebookAccessTokenForLivestream, API", error);
      setYoutubeColorCode("grey");
      if (error.response && error.response.status === 400) {
        setYoutubeMessage({
          message: error.response.data.message,
          status: 400,
        });
        console.log("Retrying getFacebookToken in 5 seconds...");
        if (retryCount < 4) {
          retryCount++;
          setTimeout(() => handleYoutubeAuthStatus(), 5000);
        } else {
          console.log("Retrying getFacebookToken in 5 seconds...");
        }
      }
      if (error.response && error.response.status === 403) {
        setYoutubeMessage({
          message: error.response.data.message,
          status: 403,
        });
      }
      if (error.response && error.response.status === 401) {
        console.log("Retrying getFacebookToken in 5 seconds...");
        if (retryCount < 4) {
          retryCount++;
          setTimeout(() => handleYoutubeAuthStatus(), 5000);
        } else {
          console.log("Retrying getFacebookToken in 5 seconds...");
        }
      }
    }
  };

  const getYoutubeComments = async (accessToken, chatId, youtubePageToken) => {
    try {
      let chatParams = {};
      if (youtubePageToken != null) {
        chatParams = {
          part: "snippet,authorDetails",
          liveChatId: chatId,
          pageToken: youtubePageToken,
        };
      } else {
        chatParams = {
          part: "snippet,authorDetails",
          liveChatId: chatId,
        };
      }
      const liveChatResponse = await ViewService.getYoutubeChatResponse(
        chatParams,
        accessToken
      );
      const data = liveChatResponse.data.items;
      console.log("chat token", liveChatResponse?.data?.nextPageToken);
      if (youtubePageToken == null) {
        youtubePageTokenRef.current = liveChatResponse?.data?.nextPageToken;
      } else {
        youtubePageTokenRef.current = liveChatResponse?.data?.nextPageToken;
        data?.forEach((commentInfo, index) => {
          if (!(commentInfo?.authorDetails?.isChatOwner == true)) {
            let obj = {
              name: commentInfo?.authorDetails?.displayName,
              comment: commentInfo?.snippet?.textMessageDetails?.messageText,
              imgUrl: commentInfo?.authorDetails?.profileImageUrl,
              id: commentInfo?.id,
              source:
                commentInfo?.authorDetails?.isChatOwner == true
                  ? "HOST"
                  : "USER",
              alignment:
                commentInfo?.authorDetails?.isChatOwner == true
                  ? "right"
                  : "left",
              isReplied: false,
              commentDetails: { ...commentInfo },
              replying_user: null,
            };
            handleYotubeComments(obj);
          }
        });

        const filterCommentsFromHost = data?.filter(
          (commentInfo) => commentInfo?.authorDetails?.isChatOwner != true
        );

        if (filterCommentsFromHost?.length > 0) {
          const commentsArray = filterCommentsFromHost?.map((commentInfo) => {
            let obj = {
              user_name: commentInfo?.authorDetails?.displayName,
              comment: commentInfo?.snippet?.textMessageDetails?.messageText,
              imgUrl: commentInfo?.authorDetails?.profileImageUrl,
              uuid: commentInfo?.id,
              user_type:
                commentInfo?.authorDetails?.isChatOwner == true
                  ? "host"
                  : "viewer",
            };
            return obj;
          });

          handlePostYoutubeLivestreamComments(commentsArray);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.status === 401) {
        console.log("Retrying getFacebookToken in 5 seconds...");
        if (youtubeCommentRetryCount < 4) {
          youtubeCommentRetryCount++;
          setTimeout(() => handleAgainYoutubeAuthStatus(), 5000);
        } else {
          message.error("Youtube Comment not Fetched");
        }
      }
    }
  };

  const getFacebookComments = async (fbStreamId) => {
    try {
      const currentTimeStamp = Math.floor(
        (Date.now() - facebookAPIPollingTime) / 1000
      );
      const response = await fetch(
        `https://graph.facebook.com/v19.0/${fbStreamId?.fb_stream_id}/comments?access_token=${fbStreamId?.token}&since=${currentTimeStamp}&fields=from,parent,message`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Facebook comments");
      }
      const data = await response.json();
      const comments = data?.data.map((item) => ({
        comment: item.message,
        uuid: item?.id,
        user_type: item?.from?.id !== fbStreamId?.page_id ? "viewer" : "host",
        user_name: item?.from?.name || "Unknown",
        ...(item?.parent && { parent_uuid: item?.parent?.id }),
      }));
      if (data?.data?.length) {
        handlePostLivestreamComments(comments, "facebook");
      }
      if (data?.data?.length > 0 && activeProductRef.current?.length > 0) {
        handleBrokerQueue(fbStreamId, data?.data);
      }
      data?.data.forEach((commentInfo, index) => {
        if (commentInfo?.from?.id !== fbStreamId?.page_id) {
          let obj = {
            name: commentInfo?.from?.name,
            comment: commentInfo.message,
            imgUrl: config.streaming_thumbnail,
            id: commentInfo?.id,
            source: "USER",
            alignment: "left",
            isReplied: false,
          };
          handleFacebookComments(obj);
        }
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getFacebookCommentsAuthId = async (fbStreamId, auth_id) => {
    try {
      console.log(facebookAPIPollingTime);
      const currentTimeStamp = Math.floor(
        (Date.now() - 15000) / 1000
      );
      console.log("fbStreamId", fbStreamId, currentTimeStamp);
      const response = await fetch(
        `https://graph.facebook.com/v19.0/${fbStreamId?.fb_stream_id}/comments?access_token=${fbStreamId?.token}&since=${currentTimeStamp}&fields=from,parent,message`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Facebook comments");
      }
      const data = await response.json();
      const comments = data?.data.map((item) => ({
        comment: item.message,
        uuid: item?.id,
        user_type: item?.from?.id !== fbStreamId?.page_id ? "viewer" : "host",
        user_name: item?.from?.name || "Unknown",
        ...(item?.parent && { parent_uuid: item?.parent?.id }),
        auth_id_config: {
          auth_id,
          ...fbStreamId
        }
      }));
      if (data?.data?.length) {
        handlePostLivestreamComments(comments, "facebook");
      }
      if (data?.data?.length > 0 && activeProductRef.current?.length > 0) {
        handleBrokerQueue(fbStreamId, data?.data);
      }
      data?.data.forEach((commentInfo, index) => {
        if (commentInfo?.from?.id !== fbStreamId?.page_id) {
          let obj = {
            name: commentInfo?.from?.name,
            comment: commentInfo.message,
            imgUrl: config.streaming_thumbnail,
            id: commentInfo?.id,
            source: "USER",
            alignment: "left",
            isReplied: false,
            auth_id_config: {
              auth_id,
              ...fbStreamId
            }
          };
          handleFacebookComments(obj);
        }
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const postCommentToYoutube = async (inputMessage) => {
    try {
      const payload = {
        snippet: {
          liveChatId: chatId,
          type: "textMessageEvent",
          textMessageDetails: {
            messageText:
              youtubeCommentsConfig != null
                ? `@${youtubeCommentsConfig?.name} , ${inputMessage}`
                : inputMessage,
          },
        },
      };
      let chatIdResponse = await ViewService.postYoutubeComment(
        payload,
        youtubeTokenRef.current
      );
      console.log(chatIdResponse);
      setYoutubeCommentsConfig(null);
      setIsInputFiledFocusd(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoginFacebook = async () => {
    window.FB.login(
      (response) => {
        if (response.status === "connected") {
          updateFacebookAuthStatus(response);
        }
      },
      {
        config_id: FACEBOOK_AUTH_CONFIG_ID,
      }
    );
  };

  const updateFacebookAuthStatus = async (configuration) => {
    try {
      const payload = {
        token: configuration?.authResponse?.accessToken,
        is_page: true,
        fb_user_id: configuration?.authResponse?.userID,
      };
      const response = await ViewService.updateAccessDetailsFacebook(payload);
      await handleFacebookAuthStatus();
      console.log("updateFacebookAuthStatus", response.data);
    } catch (error) {}
  };

  const handleFacebookComments = (newComment) => {
    setFacebookComments((prevComments) => [...prevComments, newComment]);
    handleNewCommentsNotification(newComment);
  };

  const handleYotubeComments = (newComment) => {
    setYoutubeComments((prevComments) => [...prevComments, newComment]);
  };

  const handleYoutubeLiveStreamComments = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const streamId = urlParams.get("stream_id");
      const requiredParams = {
        streaming_id: streamId,
        platform: "youtube",
      };

      let response = await ViewService.getLivestreamComments(requiredParams);
      response?.data.forEach((commentInfo, index) => {
        let commonObj = {
          name: commentInfo?.user_name,
          comment: commentInfo?.comment,
          imgUrl: commentInfo?.imgUrl,
          id: commentInfo?.uuid,
          source:
            commentInfo?.user_type == "host" ||
            commentInfo?.user_type == "moderator"
              ? "HOST"
              : "USER",
          alignment:
            commentInfo?.user_type == "host" ||
            commentInfo?.user_type == "moderator"
              ? "right"
              : "left",
          replying_user:
            commentInfo?.is_reply == true
              ? { name: commentInfo?.parent_user_name }
              : null,
          isReplied: commentInfo?.is_reply ? true : false,
        };

        handleYotubeComments(commonObj);
      });
      console.log(response.data);
    } catch (error) {
      console.log("Error in getLivestreamComments API", error);
    }
  };

  const handleNewCommentsNotification = (comments) => {
    console.log("tabRef", tabRef);
    if (tabRef.current == "1" && comments) {
      setIsNewComments(true);
    }
  };

  const handleFacebookAuthStatusForModerator = async () => {
    try {
      const response = await ViewService.getFacebookAuthStatus();
      console.log("getFacebookAuthStatus", response.data);
    } catch (error) {
      console.log(
        "Error in getFacebookAuthStatus getFacebookAuthStatus",
        error
      );
      setMessages({ message: error.response.data.message, status: 403 });
    }
  };

  const handleBrokerQueue = async (fbStreamId, comments) => {
    try {
      const filteredActiveProducts = activeProductRef.current?.filter(
        (item) => item.isLive
      );
      const result = filteredActiveProducts.map((item) => ({
        name: item?.product_name,
        image: item?.product_thumbnail,
        url: item?.product_url,
      }));
      const requiredData = {
        company_id: localStorage.getItem("companyId"),
        user_id: localStorage.getItem("user_id"),
        company_name: localStorage.getItem("company_name"),
        platform: "FB",
        request: {
          product_meta: {
            name: result[0]?.name,
            img: result[0]?.image,
            url: result[0]?.url,
          },
          meta: {
            access_token: fbStreamId?.token,
            page_id: fbStreamId?.page_id,
          },
          data: comments,
        },
      };
      let response = await ViewService.brokerQueue(requiredData);
      console.log(response.data);
    } catch (error) {
      console.log("Error in brokerQueue API", error);
    }
  };

  const handlePostLivestreamComments = async (comments, platform) => {
    try {
      const requiredData = {
        platform: platform,
        streaming_id: streamId,
        stream_info: {
          streaming_name: streamingInfoRef.current?.streaming_name,
          // addtional_info: "",
        },
        comments: comments,
      };

      let response = await ViewService.postLivestreamComments(requiredData);
      console.log(response.data);
    } catch (error) {
      console.log("Error in postLivestreamComments API", error);
    }
  };

  const handlePostYoutubeLivestreamComments = async (comments) => {
    try {
      console.log("commment", comments);
      const requiredData = {
        platform: "youtube",
        streaming_id: streamId,
        stream_info: {
          streaming_name: streamingInfoRef.current?.streaming_name,
          // addtional_info: "",
        },
        comments: comments,
      };

      let response = await ViewService.postLivestreamComments(requiredData);
      console.log(response.data);
    } catch (error) {
      console.log("Error in postLivestreamComments API", error);
    }
  };

  useEffect(() => {
    activeProductRef.current = activeProduct;
  }, [activeProduct]);

  useEffect(() => {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: FACEBOOK_AUTH_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v19.0",
      });

      window.FB.AppEvents.logPageView();
    };
  }, []);

  const handleTimeout = (timer) => {
    console.log(timer);
    setTimeout(() => {
      window.location.reload();
    }, timer * 1000);
  };

  const handleUserName = (str, num) => {
    if (str?.length <= num) {
      return str;
    }
    return str?.slice(0, num) + "...";
  };

  const [mounted, setMounted] = useState(false);

  return (
    <websocketContext.Provider
      value={{
        socket,
        handleSocket,
        setSocket,
        facebookStreamConfig,
        setFacebookStreamConfig,
        isInputFiledFocused,
        setIsInputFiledFocusd,
        facebookCommentsConfig,
        setFacebookCommentsConfig,
        facebookComments,
        setFacebookComments,
        handleFacebookAuthStatus,
        handleFacebookComments,
        isNewComments,
        setIsNewComments,
        tabRef,
        colorCode,
        messages,
        setConfig,
        handleLoginFacebook,
        handleFacebookAuthStatusForModerator,
        drawerTabRef,
        handleTimeout,
        setReplingTo,
        replingTo,
        handleUserName,
        setActiveProduct,
        streamingInfoRef,
        handlePostLivestreamComments,
        newFeeds,
        setNewFeeds,
        editItem,
        setEditItem,
        editStatus,
        setEditStatus,
        reelsSelectedRange,
        setReelsSelectedRange,
        reelsCurrentPage,
        setReelsCurrentPage,
        handleYoutubeAuthStatus,
        youtubeComments,
        youtubeColorCode,
        youtubeMessage,
        youtubeStreamConfig,
        setYoutubeCommentsConfig,
        youtubeCommentsConfig,
        handleYotubeComments,
        postCommentToYoutube,
        handleYoutubeLiveStreamComments,
        handlePostYoutubeLivestreamComments,
        authenticationRedirect,
        setAuthenticationRedirect,
        mounted,
        setMounted,
        website,
        isMobile,
        online,
        setOnline,
        hasInteracted,
        setHasInteracted,
        handleGetInstagramToken,
        instagramComments,
        postCommentToInstagram,
        setInstagramCommentConfig,
        instagramColorCode,
        handleFacebookAuthStatusAuthIds,
        multiStreamTokenConfigFacebook
        }}
    >
      {children}
    </websocketContext.Provider>
  );
};

export default WebSocketProvider;
